import Marquee from "react-fast-marquee";

export const BrandMarquee = ({ theme = "red" }) => {
  const bg = theme === "red" ? "bg-dst-red" : theme === "navy" ? "bg-dst-navy" : "bg-dst-ink";
  const items = [
    "WE DON'T SIMPLY IMPROVE ATHLETES",
    "WE DEVELOP COMPETITORS",
    "ACCOUNTABILITY",
    "DISCIPLINE",
    "MINDSET",
  ];
  return (
    <div data-testid="brand-marquee" className={`${bg} py-5 border-y border-white/10 overflow-hidden`}>
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-oswald uppercase font-600 tracking-tight text-white text-3xl sm:text-4xl px-8">
              {t}
            </span>
            <span className="text-white/40 text-3xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
